import compose from "../utils/compose";
import withResponsive from "../hoc/withResponsive";
import withScroll from "../hoc/withScroll";

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, ANCHORS will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default compose(
  withResponsive,
  withScroll
)({
  name: "anchors",

  ui: {
    "anchors[]": "[js-anchor]"
  },

  events: [
    {
      target: "anchors",
      on: "click",
      handle(e) {
        e.preventDefault();
        //if(screen.width <= 768) return;
        const targetHref = e.target.getAttribute("href");
        const target = document.querySelector(targetHref);
        const offset = this.isMobile
          ? this.headerOffset + 20
          : this.headerOffset + 100; //(document.documentElement.scrollTop > target.offsetTop) ? this.headerOffset : this.headerOffset //0
        const pos = target.offsetTop - offset;

        window.scrollTo({
          top: pos,
          behavior: "smooth"
        });

        if (this.isMobile)
          setTimeout(() => {
            this.el.classList.remove("is-opened");
          }, 100);
      }
    }
  ],

  isMobile: false,
  headerOffset: document.querySelector(".app-supheader").offsetHeight + 91,

  componentDidMount() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    this.iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    this.anchorsTargets = document.querySelectorAll(".js-anchor-target");
    this.anchorsWrapper = this.el;
    this.content = document.querySelector(".js-cs-content");
    this.isScrolling = false; //screen.width <= 768 ? true : false;
    this.timer = 0;

    window.addEventListener("resize", this.resize);
    this.resize();

    this.checkVisibility();
    this.checkActiveAnchor();
  },
  /*
  componentWillUnmount () {
    console.log('[ANCHORS] will unmount')
  },
*/

  onScroll({ y }) {
    if (this.isScrolling) return;
    this.checkVisibility(y);
    this.checkActiveAnchor();
  },

  checkVisibility(scrollDistance) {
    if (this.content.offsetTop - this.headerOffset <= scrollDistance) {
      this.anchorsWrapper.classList.add("is-visible");
      if (this.anchorsWrapper.classList.contains("anchors--opened")) {
        clearTimeout(this.timer);
        this.timer = setTimeout(_ => {
          this.anchorsWrapper.classList.remove("anchors--opened");
        }, 3000);
      }
    } else {
      this.anchorsWrapper.classList.remove("is-visible");
    }
  },

  checkActiveAnchor() {
    this.anchorsTargets.forEach((target, i) => {
      const rect = target.getBoundingClientRect(),
        vpH = window.innerHeight,
        slice = target.parentNode.querySelector(
          "#" + target.getAttribute("id") + "+ .slice"
        ),
        sliceH = slice.offsetHeight;
      /*slice.style.border = "1px solid red"
        console.log('----------------- START slice',i, '-----------------')
        console.log(slice)
        console.log('rect.top',rect.top)
        console.log('sliceH',sliceH)
        console.log('vpH / 2 ',vpH / 2 )
        console.log(rect.top < vpH / 2 )
        console.log(rect.top + sliceH > vpH / 2 )
        console.log('----------------- END slice',i, '-----------------')*/
      //if(target.offsetTop - this.headerOffset <= scrollDistance) {
      if (rect.top < vpH / 2 && rect.top + sliceH > vpH / 2) {
        this.ui.anchors.forEach((anchor, j) => {
          if (i === j) {
            anchor.classList.add("is-active");
            if (this.isMobile) {
              let parent = anchor.parentNode;
              let list = parent.parentNode;
              list.style.transform =
                "translateY(" + -j * parent.offsetHeight + "px)";
            }
          } else {
            anchor.classList.remove("is-active");
          }
        });
      }
    });
  },

  resize() {
    let winW = window.innerWidth;
    if (winW < 768) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.el.classList.remove("is-opened");
    this.headerOffset =
      document.querySelector(".app-supheader").offsetHeight + 91;
  }
});
